import emitter, { EventTypes } from './eventEmitter';

export default (formName, fn) =>
  emitter.emit(EventTypes.DISPATCH_IN_FORM, formName, fn);
